import React, { useState } from 'react'
import {
  Button,
  Dialog,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Checkbox,
  Select,
  Option,
  Textarea,

} from "@material-tailwind/react";
import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import DeliveryLogo from "../../asset/delhivery.png"
import GRCLogo from "../../asset/grc-logo.png"
import trackonlogo from "../../asset/trackon.png"
import bluedart from "../../asset/bluedartlogo.png"
import dtdc from "../../asset/dtdclogo.png"
import toast from 'react-hot-toast';
import { supabase } from '../../supabase.config';
import { emitOrderNotification } from '../../utils/notificationService';

const ChoosePartner = ({ partnerModal, handlePartnerModal, setPartnerModal, handleDeliveryShipping, handleOwnShipping, orderActivity, setForwardNumber, partner, setPartner, forwardNumber, orderID, orderIDs = [], onShipSuccess }) => {
  const [showAutocomplete, setShowAutocomplete] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleSubmit = async () => {
    setLoading(true)
    const date = new Date()
    try {
      const { data: authData } = await supabase.auth.getUser()
      const actorUserId = authData?.user?.id || null
      const targetOrderIds = Array.isArray(orderIDs) && orderIDs.length ? orderIDs : [orderID].filter(Boolean)
      if (!targetOrderIds.length) throw new Error('No orders selected')

      const { data: currentOrders, error } = await supabase.from('orders').select('*').in('id', targetOrderIds)
      if (error) throw error
      if (!currentOrders?.length) throw new Error('No matching orders found')

      const updates = currentOrders.map(async (current) => {
        const pkg = (typeof current?.package_details === 'object') ? current.package_details : (() => { try { return JSON.parse(current?.package_details || '{}') } catch { return {} } })()
        const updatedPkg = {
          ...pkg,
          partner: partner,
          orderActivity: [...(pkg.orderActivity || []), {
            status: 'Picked Up',
            remark: 'Order has been Pickedup',
            location: 'GRC Bhiwandi',
            time: date
          }]
        }
        const isGrc = String(partner || '').toUpperCase() === 'GRC'
        const updateFields = {
          status: 'pickedUp',
          package_details: updatedPkg,
          forwarding_partner: partner || null,
          forwarding_number: isGrc ? (current?.tracking_number || current?.order_number || null) : (forwardNumber || null)
        }

        const { error: updErr } = await supabase.from('orders').update(updateFields).eq('id', current.id)
        if (updErr) throw updErr

        await emitOrderNotification({
          actorUserId,
          order: { ...current, ...updateFields, package_details: updatedPkg },
          eventType: 'forwarding_partner_assigned',
          title: 'Forwarding partner assigned',
          message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was assigned to ${partner || 'a partner'}.`,
          metadata: {
            forwardingPartner: partner || null,
            forwardingNumber: updateFields.forwarding_number,
          },
        })
      })

      await Promise.all(updates)

      toast.success(`${currentOrders.length} order${currentOrders.length === 1 ? '' : 's'} updated`)
      setForwardNumber('')
      setPartner('')
      setPartnerModal(false)
      if (typeof onShipSuccess === 'function') {
        onShipSuccess(targetOrderIds)
      }
    } catch (err) {
      console.error(err)
      toast.error("Failed to update forward number")
    } finally {
      setLoading(false)
    }
  }
  return (
    <div className='relative z-[999]'>
      <div>
        <Dialog
          size="xs"
          open={partnerModal}
          handler={handlePartnerModal}
          className="bg-transparent  shadow-none"
        >
          <Card className="lg:mx-auto  relative    w-full ">
            <div className='px-6 pt-4 flex items-center justify-between' >
              <div className='' >
                <h3 className='text-[1.4rem] font-[GilroyBold]' >Choose a Partner</h3>
              </div>
              <div onClick={() => setPartnerModal(!partnerModal)} className=" cursor-pointer w-[40px] h-[40px]" >
                <XMarkIcon className='w-[30px]' />
              </div>
            </div>
            <CardBody className="h-[250px] mt-4 overflow-y-scroll ">
              <div className='flex flex-col justify-center items-center gap-5'>
                <Select value={partner} onChange={(e) => setPartner(e)} className='h-[50px] font-[GilroyMedium]' label='Choose a partner' >
                  <Option value='GRC' ><div className='flex my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                    <img className='w-[80px]' src={GRCLogo} />
                    <h3>Shipping By Own</h3>
                  </div></Option>
                  <Option value='Delivery' >
                    <div className='flex h-[30px] my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                      <img className='w-[80px]' src={DeliveryLogo} />
                      <h3>Shipping By Delivery</h3>
                    </div>
                  </Option>
                  <Option value='Trackon' >
                    <div className='flex h-[30px]  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                      <img className='w-[80px]' src={trackonlogo} />
                      <h3>Shipping By Trackon</h3>
                    </div>
                  </Option>
                  <Option value='Bluedart' >
                    <div className='flex h-[30px] my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                      <img className='w-[80px]' src={bluedart} />
                      <h3>Shipping By Blue Dart</h3>
                    </div>
                  </Option>
                  <Option value='DTDC' >
                    <div className='flex h-[30px]  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                      <img className='w-[80px]' src={dtdc} />
                      <h3>Shipping By DTDC</h3>
                    </div>
                  </Option>
                </Select>
                {partner && partner !== "GRC" && <Input
                  label="Forward Number"
                  value={forwardNumber}
                  onChange={(e) => setForwardNumber(e.target.value)}
                />}
                <Button
                  onClick={handleSubmit} loading={loading} disabled={loading}
                >
                  {loading ? "Saving..." : "Save & Proceed"}
                </Button>
                {/* <div onClick={handleOwnShipping} className='flex my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                  <img className='w-[80px]' src={GRCLogo} />
                  <h3>Shipping By Own</h3>
                </div>
                <div onClick={handleForwardnoModal} className='flex  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                  <img className='w-[80px]' src={DeliveryLogo} />
                  <h3>Shipping By Delivery</h3>
                </div>
                <div onClick={handleForwardnoModal} className='flex  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                  <img className='w-[80px]' src={trackonlogo} />
                  <h3>Shipping By Trackon</h3>
                </div>
                <div onClick={handleForwardnoModal} className='flex  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                  <img className='w-[80px]' src={bluedart} />
                  <h3>Shipping By Blue Dart</h3>
                </div>
                <div onClick={handleForwardnoModal} className='flex  my-4 hover:bg-[#d8d8d8a6] cursor-pointer items-center justify-start py-4 rounded-lg gap-8 px-4' >
                  <img className='w-[80px]' src={dtdc} />
                  <h3>Shipping By DTDC</h3>
                </div> */}
              </div>

            </CardBody>

          </Card>
        </Dialog>
      </div>
    </div>
  )
}

export default ChoosePartner
